import { Box } from '@mui/material';
import { RenderTable } from '../../../../components/ui';
import TBody from './TBody';
import THead from './THead';
import TFoot from './TFoot';

interface IProps {
  moduleData: any;
  isView: boolean;
  calculateCumulative: any;
}

const TController = ({ moduleData, isView, calculateCumulative }: IProps) => {
  return (
    <Box>
      <RenderTable>
        <THead
          {...{
            moduleData,
            isView,
            calculateCumulative,
          }}
        />
        <TBody
          {...{
            moduleData,
            isView,
            calculateCumulative,
          }}
        />
        <TFoot />
      </RenderTable>
    </Box>
  );
};

export default TController;
